/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cerez_S3_Th_RetentionInputs */

const tr_cerez_s3_th_retention = /** @type {(inputs: Cerez_S3_Th_RetentionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saklama Süresi`)
};

const en_cerez_s3_th_retention = /** @type {(inputs: Cerez_S3_Th_RetentionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retention period`)
};

const de_cerez_s3_th_retention = /** @type {(inputs: Cerez_S3_Th_RetentionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speicherdauer`)
};

const ru_cerez_s3_th_retention = /** @type {(inputs: Cerez_S3_Th_RetentionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Срок хранения`)
};

/**
* | output |
* | --- |
* | "Retention period" |
*
* @param {Cerez_S3_Th_RetentionInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const cerez_s3_th_retention = /** @type {((inputs?: Cerez_S3_Th_RetentionInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cerez_S3_Th_RetentionInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cerez_s3_th_retention(inputs)
	if (locale === "de") return de_cerez_s3_th_retention(inputs)
	if (locale === "ru") return ru_cerez_s3_th_retention(inputs)
	return tr_cerez_s3_th_retention(inputs)
});